<template>
  <div class="slots">
    <toolbar
      backRoute="/dashboard"
      title="Slot summary"
      :addButton="false" />

    <table class="table table-striped table-bordered table-hover mt-5">
      <thead>
        <tr>
          <th colspan="3"></th>
          <th colspan="2" class="text-center bg-blue">Request</th>
          <th colspan="2" class="text-center bg-green">Granted</th>
          <th colspan="2"></th>
        </tr>
        <tr>
          <th>Date</th>
          <th>Aircraft</th>
          <th>Location</th>
          <th class="text-center">ARR</th>
          <th class="text-center">DEP</th>
          <th class="text-center">ARR</th>
          <th class="text-center">DEP</th>
          <th>Tolerance</th>
          <th>User note</th>
        </tr>
      </thead>

      <tbody v-if="!loadError">
        <tr v-if="!allDataLoaded">
          <td
            colspan="9"
            class="text-center">
            Loading slot summary&hellip;
          </td>
        </tr>
        <tr v-if="allDataLoaded && slots.length === 0">
            <td
              colspan="9"
              class="text-center">
              There are no slot summary data to display&hellip;
            </td>
          </tr>
        <template v-for="(slot, index) of slots">
          <template v-if="slot.slot_departure_requested_time || slot.slot_departure_granted_time">
            <tr
              :key="'slot-departure-' + index"
              :data-slot-status="slotStatus(slot, 'departure')">
              <td class="align-middle" style="width: 130px;">
                <template v-if="slot.departure_airport">
                  <strong
                    v-if="slot.slot_departure_granted_date"
                    class="text-green">
                    {{ slot.slot_departure_granted_date | displayDate }}
                  </strong>
                  <strong
                    v-else-if="slot.slot_departure_requested_date"
                    class="text-blue">
                    {{ slot.slot_departure_requested_date | displayDate }}
                  </strong>
                  <strong
                    v-else
                    style="color: #888;">
                    {{ slot.departure_date | displayDate }}
                  </strong>
                </template>
              </td>

              <td class="align-middle" style="width: 130px;">{{ slot.aircraft.regin_mark }}</td>
              <td class="align-middle" style="width: 100px;">{{ slot.departure_airport.icao }}</td>

              <td></td>

              <td
                v-if="slot.departure_airport"
                :key="'slot-departure-requested-cell-non-empty-' + index"
                :class="{
                  'align-middle': true,
                  'text-center': true,
                  'not-yet-issued': slot.departure_airport.slot_required && !slot.slot_departure_requested_time
                }"
                @click.prevent="$router.push('/dashboard/fligths/' + parseInt(slot.id, 10) + '/slotdetails');"
                style="width: 100px; cursor: pointer;">
                {{ slot.slot_departure_requested_time }}
              </td>
              <td
                v-else
                @click.prevent="$router.push('/dashboard/fligths/' + parseInt(slot.id, 10) + '/slotdetails');"
                style="cursor: pointer;"
                :key="'slot-departure-requested-cell-empty-' + index">
              </td>

              <td></td>

              <td
                v-if="slot.departure_airport"
                :key="'slot-departure-granted-cell-non-empty-' + index"
                :class="{
                  'align-middle': true,
                  'text-center': true,
                  'not-yet-issued': slot.departure_airport.slot_required && !slot.slot_departure_granted_time
                }"
                @click.prevent="$router.push('/dashboard/fligths/' + parseInt(slot.id, 10) + '/slotdetails');"
                style="width: 100px; cursor: pointer;">
                {{ slot.slot_departure_granted_time }}
              </td>
              <td
                v-else
                @click.prevent="$router.push('/dashboard/fligths/' + parseInt(slot.id, 10) + '/slotdetails');"
                style="cursor: pointer;"
                :key="'slot-departure-granted-cell-empty-' + index">
              </td>

              <td class="align-middle text-center" style="width: 100px;">
                <template v-if="slot.departure_airport.slot_required">
                  -{{ slot.departure_airport.departure_slot_tolerance_before }} /
                  +{{ slot.departure_airport.departure_slot_tolerance_after }}
                </template>
              </td>
              <td class="align-middle py-1" style="width: 320px;">
                {{ slot.slot_departure_notes }}
              </td>
            </tr>
          </template>

          <template v-if="slot.slot_arrival_requested_time || slot.slot_arrival_granted_time">
            <tr
              :key="'slot-arrival-' + index"
              :data-slot-status="slotStatus(slot, 'arrival')">
              <td class="align-middle" style="width: 130px;">
                <template v-if="slot.arrival_airport">
                  <strong
                    v-if="slot.slot_arrival_granted_date"
                    class="text-green">
                    {{ slot.slot_arrival_granted_date | displayDate }}
                  </strong>
                  <strong
                    v-else-if="slot.slot_arrival_requested_date"
                    class="text-blue">
                    {{ slot.slot_arrival_requested_date | displayDate }}
                  </strong>
                  <strong
                    v-else
                    style="color: #888;">
                    {{ slot.arrival_date | displayDate }}
                  </strong>
                </template>
              </td>

              <td class="align-middle" style="width: 130px;">{{ slot.aircraft.regin_mark }}</td>
              <td class="align-middle" style="width: 100px;">{{ slot.arrival_airport.icao }}</td>

              <td
                v-if="slot.arrival_airport"
                :key="'slot-arrival-requested-cell-non-empty-' + index"
                :class="{
                  'align-middle': true,
                  'text-center': true,
                  'not-yet-issued': slot.arrival_airport.slot_required && !slot.slot_arrival_requested_time
                }"
                style="width: 100px; cursor: pointer;"
                @click.prevent="$router.push('/dashboard/fligths/' + parseInt(slot.id, 10) + '/slotdetails');">
                {{ slot.slot_arrival_requested_time }}
              </td>
              <td
                v-else
                @click.prevent="$router.push('/dashboard/fligths/' + parseInt(slot.id, 10) + '/slotdetails');"
                style="cursor: pointer;"
                :key="'slot-arrival-requested-cell-empty-' + index">
              </td>
              <td></td>

              <td
                v-if="slot.arrival_airport"
                :key="'slot-arrival-granted-cell-non-empty-' + index"
                :class="{
                  'align-middle': true,
                  'text-center': true,
                  'not-yet-issued': slot.arrival_airport.slot_required && !slot.slot_arrival_granted_time
                }"
                @click.prevent="$router.push('/dashboard/fligths/' + parseInt(slot.id, 10) + '/slotdetails');"
                style="width: 100px; cursor: pointer;">
                {{ slot.slot_arrival_granted_time }}
              </td>
              <td
                v-else
                @click.prevent="$router.push('/dashboard/fligths/' + parseInt(slot.id, 10) + '/slotdetails');"
                style="cursor: pointer;"
                :key="'slot-arrival-granted-cell-empty-' + index">
              </td>
              <td></td>

              <td class="align-middle text-center" style="width: 100px;">
                <template v-if="slot.arrival_airport.slot_required">
                  -{{ slot.arrival_airport.arrival_slot_tolerance_before }} /
                  +{{ slot.arrival_airport.arrival_slot_tolerance_after }}
                </template>
              </td>
              <td class="align-middle py-1" style="width: 320px;">
                {{ slot.slot_arrival_notes }}
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      An error occurred during data loading. <a href="javascript:window.location.reload();" class="alert-link">Reload the page</a> to try again.
    </d-alert>

    <pagination :meta-data="paginationMetaData" />
  </div>
</template>

<script>
import DateUtils from './../utils/DateUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'slots',
  endpoint: 'trips/slot-summary',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  filters: {
    displayDate (value) {
      if (value) {
        let input = new Date(value);

        return [
          input.getDate(),
          DateUtils.getMonthShortName(input.getMonth() + 1),
          input.getFullYear().toString().substr(2, 2)
        ].map(n => n < 10 ? '0' + n : n).join('-');
      }

      return '';
    }
  },
  data () {
    return {
      loaded: false,
      slots: null,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    slotStatus (slotData, type) {
      if (
        type === 'departure' &&
        slotData.departure_airport.slot_required &&
        slotData.slot_departure_requested_date &&
        slotData.slot_departure_granted_date &&
        slotData.slot_departure_requested_time &&
        slotData.slot_departure_granted_time
      ) {
        let allowedBefore = 0;
        let allowedAfter = 0;
        let requestedDate = new Date(slotData.slot_departure_requested_date);
        let grantedDate = new Date(slotData.slot_departure_granted_date);
        let requestedHours = parseInt(slotData.slot_departure_requested_time.substr(0, 2), 10);
        let requestedMinutes = parseInt(slotData.slot_departure_requested_time.substr(2, 2), 10);
        let grantedHours = parseInt(slotData.slot_departure_granted_time.substr(0, 2), 10);
        let grantedMinutes = parseInt(slotData.slot_departure_granted_time.substr(2, 2), 10);

        requestedDate.setHours(requestedHours);
        requestedDate.setMinutes(requestedMinutes);
        requestedDate.setSeconds(0);
        requestedDate.setMilliseconds(0);
        grantedDate.setHours(grantedHours);
        grantedDate.setMinutes(grantedMinutes);
        grantedDate.setSeconds(0);
        grantedDate.setMilliseconds(0);

        if (slotData.departure_airport.departure_slot_tolerance_after !== null || slotData.departure_airport.departure_slot_tolerance_after !== '') {
          allowedBefore = parseInt(slotData.departure_airport.departure_slot_tolerance_before, 10);
          allowedAfter = parseInt(slotData.departure_airport.departure_slot_tolerance_after, 10);
        }

        let slotAllowedStart = new Date(requestedDate);
        slotAllowedStart.setMinutes(requestedDate.getMinutes() - allowedBefore);
        let slotAllowedEnd = new Date(requestedDate);
        slotAllowedEnd.setMinutes(requestedDate.getMinutes() + allowedAfter);

        if (grantedDate.getTime() >= slotAllowedStart.getTime() && grantedDate.getTime() <= slotAllowedEnd.getTime()) {
          return 'success';
        }

        return 'error';
      } else if (
        type === 'arrival' &&
        slotData.arrival_airport.slot_required &&
        slotData.slot_arrival_requested_date &&
        slotData.slot_arrival_granted_date &&
        slotData.slot_arrival_requested_time &&
        slotData.slot_arrival_granted_time
      ) {
        let allowedBefore = 0;
        let allowedAfter = 0;
        let requestedDate = new Date(slotData.slot_arrival_requested_date);
        let grantedDate = new Date(slotData.slot_arrival_granted_date);
        let requestedHours = parseInt(slotData.slot_arrival_requested_time.substr(0, 2), 10);
        let requestedMinutes = parseInt(slotData.slot_arrival_requested_time.substr(2, 2), 10);
        let grantedHours = parseInt(slotData.slot_arrival_granted_time.substr(0, 2), 10);
        let grantedMinutes = parseInt(slotData.slot_arrival_granted_time.substr(2, 2), 10);

        requestedDate.setHours(requestedHours);
        requestedDate.setMinutes(requestedMinutes);
        requestedDate.setSeconds(0);
        requestedDate.setMilliseconds(0);
        grantedDate.setHours(grantedHours);
        grantedDate.setMinutes(grantedMinutes);
        grantedDate.setSeconds(0);
        grantedDate.setMilliseconds(0);

        if (slotData.arrival_airport.arrival_slot_tolerance_after !== null || slotData.arrival_airport.arrival_slot_tolerance_after !== '') {
          allowedBefore = parseInt(slotData.arrival_airport.arrival_slot_tolerance_before, 10);
          allowedAfter = parseInt(slotData.arrival_airport.arrival_slot_tolerance_after, 10);
        }

        let slotAllowedStart = new Date(requestedDate);
        slotAllowedStart.setMinutes(requestedDate.getMinutes() - allowedBefore);
        let slotAllowedEnd = new Date(requestedDate);
        slotAllowedEnd.setMinutes(requestedDate.getMinutes() + allowedAfter);

        if (grantedDate.getTime() >= slotAllowedStart.getTime() && grantedDate.getTime() <= slotAllowedEnd.getTime()) {
          return 'success';
        }

        return 'error';
      }

      return 'unknown';
    }
  }
};
</script>

<style lang="scss">
.not-yet-issued {
  background: lighten(#ff0, 35);
}

thead {
  background: #fff;
  position: sticky;
  top: 0;

  th {
    background: #fff;
  }
}

tr[data-slot-status="success"] {
  td:nth-child(4),
  td:nth-child(5),
  td:nth-child(6),
  td:nth-child(7) {
    color: green;
  }
}

tr[data-slot-status="error"] {
  td:nth-child(4),
  td:nth-child(5),
  td:nth-child(6),
  td:nth-child(7) {
    color: red;
  }
}

.bg-blue {
  background: rgb(183, 193, 228);
}

.bg-green {
  background: rgb(203, 233, 184);
}

.text-blue {
  color: darken(rgb(183, 193, 228), 25%);
}

.text-green {
  color: darken(rgb(203, 233, 184), 25%);
}

td strong {
  font-weight: bold;
}
</style>
